import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"

const useStyles = makeStyles({
	card: {
		backgroundColor: colors.purple[500],
		borderRadius: "8px",
		padding: "10px 12px",
		cursor: "pointer",
		gap: "10px",
		marginLeft: "12px",
		marginRight: "12px",
		"&:hover": {
			backgroundColor: colors.purple[600]
		},
		transition: "background-color 0.2s ease"
	},
	cardCollapsed: {
		margin: "6px auto",
		padding: "8px",
		justifyContent: "center",
		alignSelf: "center",
		width: "fit-content"
	},
	iconBox: {
		width: "32px",
		height: "32px",
		borderRadius: "5px",
		backgroundColor: colors.purple[400],
		flexShrink: 0,
		color: colors.gray[0]
	},
	textContainer: {
		flex: 1,
		minWidth: 0
	},
	instanceIdText: {
		fontSize: "11px",
		color: colors.gray[0],
		lineHeight: 1.3,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis"
	},
	instanceNameText: {
		fontSize: "12px",
		color: colors.gray[0],
		lineHeight: 1.3,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
		fontWeight: 600
	},
	chevron: {
		flexShrink: 0,
		color: colors.gray[0]
	}
})

export default useStyles
